<template>
  <div style="display: inline-block">
    <v-btn v-if="type == 'edit'" color="primary" outline icon small @click.stop="openModal">
      <v-icon small>edit</v-icon>
    </v-btn>
    <v-btn
      v-if="type == 'add'"
      color="primary"
      outline
      :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
      @click="openModal"
      ><v-icon>add</v-icon>Add</v-btn
    >
    <v-dialog v-model="showManage" persistent max-width="600">
      <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup">
        <v-layout>
          <v-flex class="pl-4 pt-3">
            <h3 class="title">{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn small fab flat :loading="loading || loadingTicket" @click="onCancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <div v-if="type == 'add'" class="text-xs-right">
            <v-autocomplete
              v-model="select"
              return-object
              label="Find customer"
              solo
              :loading="loading"
              :items="items"
              :search-input.sync="search"
              outline
              prepend-inner-icon="search"
              :item-text="'first_name'"
              :item-value="'id'"
              class="default-input"
              @change="onChangeSelect"
            >
              <template #item="data">
                <template v-if="checkObject(data.item)">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar>
                    <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                    <img v-else :src="'/static/img/assets/livechat/profile.png'" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="data.item.first_name + ' ' + data.item.last_name"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.app"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>

              <template #append-outer>
                <v-icon
                  :key="`icon-delete`"
                  :disabled="!select"
                  @click="onClearCustomer"
                  v-text="'delete'"
                ></v-icon>
              </template>
            </v-autocomplete>
          </div>
          <v-layout wrap>
            <template v-if="!livechat">
              <v-flex
                xs12
                sm6
                class="form-control px-1"
                :class="{ 'has-error': errors.has('firstname') }"
              >
                <div class="caption mb-1 mt-2">Customer First Name *</div>
                <template>
                  <input
                    v-model="ticket.contact_firstname"
                    v-validate="'required'"
                    type="text"
                    :placeholder="$t('customer first name')"
                    class="form-control"
                    maxlength="255"
                    :data-vv-as="$t('Customer First Name')"
                    name="firstname"
                  />
                </template>
                <p v-if="errors.has('firstname')" class="text-error">
                  {{ errors.first('firstname') }}
                </p>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Customer Last Name</div>
                <template>
                  <input
                    v-model="ticket.contact_lastname"
                    type="text"
                    :placeholder="$t('customer last name')"
                    class="form-control"
                    maxlength="255"
                  />
                </template>
              </v-flex>

              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Email</div>
                <input
                  v-model="ticket.contact_email"
                  type="text"
                  :placeholder="$t('Email')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Phone No</div>
                <input
                  v-model="ticket.contact_phone"
                  type="number"
                  :placeholder="$t('Phone No')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>

              <v-flex xs12>
                <v-divider class="my-3" />
              </v-flex>
            </template>
            <template v-if="type == 'add'">
              <v-flex
                xs12
                sm6
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('group') }"
              >
                <div class="caption mb-1 mt-2">Group</div>
                <v-autocomplete
                  v-model="ticket.group"
                  return-object
                  name="group"
                  :loading="loading"
                  :items="agentGroup"
                  outline
                  clearable
                  :item-text="'groupname'"
                  :item-value="'groupname'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('group')"
                  :error="errors.has('group')"
                  :error-messages="errors.first('group')"
                  placeholder="Group"
                  @change="onChangeGroup"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Subgroup</div>
                <v-autocomplete
                  v-model="ticket.subgroup"
                  return-object
                  name="subgroup"
                  :loading="loading"
                  :items="filterSubGroup"
                  outline
                  clearable
                  :item-text="'subgroupname'"
                  :item-value="'subgroupname'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('subgroup')"
                  :error="errors.has('subgroup')"
                  :error-messages="errors.first('subgroup')"
                  placeholder="Sub Group"
                  @change="onChangeSubGroup"
                />
              </v-flex>
              <v-flex xs12 sm12 class="form-control px-1 pb-2 has-error">
                <div class="caption mb-1 mt-2">Assigned to&nbsp;*</div>
                <v-autocomplete
                  v-model="ticket.assignedTo"
                  return-object
                  name="assignedTo"
                  :loading="loading"
                  :items="filterAgents"
                  outline
                  clearable
                  :item-text="'name'"
                  :item-value="'name'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('assignedTo')"
                  :error="errors.has('assignedTo')"
                  :error-messages="errors.first('assignedTo')"
                  placeholder="Assigned to"
                />
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Group</div>
                <v-autocomplete
                  v-model="ticket.group"
                  return-object
                  name="group"
                  :loading="loading"
                  :items="agentGroup"
                  outline
                  clearable
                  :item-text="'groupname'"
                  :item-value="'groupname'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('group')"
                  :error="errors.has('group')"
                  :error-messages="errors.first('group')"
                  placeholder="Group"
                  @change="onChangeGroup"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Subgroup</div>
                <v-autocomplete
                  v-model="ticket.subgroup"
                  return-object
                  name="subgroup"
                  :loading="loading"
                  :items="filterSubGroup"
                  outline
                  clearable
                  :item-text="'subgroupname'"
                  :item-value="'subgroupname'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('subgroup')"
                  :error="errors.has('subgroup')"
                  :error-messages="errors.first('subgroup')"
                  placeholder="Sub Group"
                  @change="onChangeSubGroup"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Assigned to</div>
                <v-autocomplete
                  v-model="ticket.assignedTo"
                  return-object
                  name="assignedTo"
                  :loading="loading"
                  :items="filterAgents"
                  outline
                  clearable
                  :item-text="'name'"
                  :item-value="'name'"
                  class="default-input"
                  single-line
                  :hide-details="!errors.has('assignedTo')"
                  :error="errors.has('assignedTo')"
                  :error-messages="errors.first('assignedTo')"
                  placeholder="Assigned to"
                />
              </v-flex>
            </template>

            <v-flex xs12 class="form-control px-1" :class="{ 'has-error': errors.has('subject') }">
              <div class="caption mb-1 mt-2">Subject *</div>
              <input
                v-model="ticket.subject"
                v-validate="'required'"
                type="text"
                :placeholder="$t('Subject')"
                class="form-control"
                maxlength="255"
                :data-vv-as="$t('Subject')"
                name="subject"
              />
              <p v-if="errors.has('subject')" class="text-error">{{ errors.first('subject') }}</p>
            </v-flex>
            <v-flex xs12 class="form-control px-1" :class="{ 'has-error': errors.has('details') }">
              <div class="caption mb-1 mt-2">Details *</div>
              <textarea
                id="details"
                v-model="ticket.details"
                v-validate="'required'"
                name="details"
                style="width: 100%; min-height: 100px"
                :data-vv-as="$t('Details')"
                class="form-control"
                :placeholder="$t('Details')"
              ></textarea>
              <p v-if="errors.has('details')" class="text-error">{{ errors.first('details') }}</p>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="caption mb-1 mt-2">Priority *</div>
              <v-autocomplete
                v-model="priority"
                v-validate="'required'"
                return-object
                name="priority"
                :loading="loading"
                :items="priorityOptions"
                outline
                clearable
                :item-text="'text'"
                :item-value="'value'"
                class="default-input"
                single-line
                :hide-details="!errors.has('priority')"
                :error="errors.has('priority')"
                :error-messages="errors.first('priority')"
                placeholder="Priority"
              />
            </v-flex>

            <v-flex
              xs12
              sm6
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('status') }"
            >
              <div class="caption mb-1 mt-2">Status *</div>
              <v-autocomplete
                v-model="ticket.status"
                v-validate="'required'"
                name="status"
                :loading="loading"
                :items="statusOptions"
                outline
                clearable
                class="default-input"
                single-line
                :hide-details="!errors.has('status')"
                :error="errors.has('status')"
                :error-messages="errors.first('status')"
                placeholder="Status"
              />
            </v-flex>

            <v-flex
              xs12
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('channel') }"
            >
              <div class="caption mb-1 mt-2">Channel *</div>

              <v-radio-group
                v-model="ticket.channel"
                v-validate="'required'"
                d-inline
                row
                :data-vv-as="$t('Channel')"
                name="channel"
              >
                <v-radio
                  class="mb-2"
                  :value="'facebook'"
                  color="primary"
                  label="Facebook"
                ></v-radio>
                <v-radio class="mb-2" :value="'line'" color="primary" label="Line"></v-radio>
              </v-radio-group>
              <p v-if="errors.has('channel')" class="text-error">{{ errors.first('channel') }}</p>
            </v-flex>

            <v-flex xs12>
              <div class="caption mb-1 mt-2">Tags</div>
              <v-combobox
                v-model="tags"
                :filter="tagsfilter"
                :hide-no-data="!tagssearch"
                :items="tagitems"
                :search-input.sync="tagssearch"
                hide-selected
                label="Search for an option"
                multiple
                small-chips
                solo
              >
                <template #no-data>
                  <v-list-tile>
                    <span class="subheading">Create</span>
                    <v-chip :color="`primary lighten-3`" label small>{{ tagssearch }}</v-chip>
                  </v-list-tile>
                </template>
                <template #selection="{ item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    :color="`primary lighten-3`"
                    :selected="selected"
                    label
                    small
                  >
                    <span class="pr-2">{{ item.text }}</span>
                    <v-icon small @click="parent.selectItem(item)">close</v-icon>
                  </v-chip>
                </template>
                <template #item="{ index, item }">
                  <v-list-tile-content>
                    <v-text-field
                      v-if="tagediting === item"
                      v-model="tagediting.text"
                      autofocus
                      flat
                      background-color="transparent"
                      hide-details
                      solo
                      @keyup.enter="tagsedit(index, item)"
                    ></v-text-field>
                    <v-chip v-else :color="`primary lighten-3`" label small>{{ item.text }}</v-chip>
                  </v-list-tile-content>
                  <v-spacer></v-spacer>
                  <v-list-tile-action @click.stop>
                    <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                      <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
              </v-combobox>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs12 sm7 class="px-1 form-control">
              <div class="caption">Due Date</div>
              <datepicker
                v-model="duedate.start"
                color="primary"
                @selected="onSelectedDueDate"
              ></datepicker>
            </v-flex>
            <v-flex xs6 sm4 class="px-1 form-control">
              <div class="caption">Time</div>

              <v-dialog
                ref="starttime"
                v-model="showDueTimeDialog"
                :return-value.sync="duedate.starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template #activator="{ on }">
                  <v-layout>
                    <input
                      v-model="duedate.starttime"
                      type="text"
                      readonly
                      placeholder="00:00"
                      :disabled="duedate.start == null"
                      v-on="on"
                    />
                  </v-layout>
                </template>
                <v-time-picker v-if="showDueTimeDialog" v-model="duedate.starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showDueTimeDialog = false">{{
                    $t('cancel')
                  }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(duedate.starttime)
                      showDueTimeDialog = false
                      onSelectedDueDate(duedate.end)
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs2 sm1>
              <div class="caption">&nbsp;</div>
              <v-btn
                fab
                flat
                small
                @click="
                  duedate.starttime = null
                  duedate.start = null
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <v-btn outline color="grey" :loading="loading || loadingTicket" @click="onCancel">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn color="primary" depressed :loading="loading || loadingTicket" @click="onSave">{{
              $t('Save')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TicketEdit from './TicketEdit.js'
export default {
  name: 'TicketEdit2',
  mixins: [TicketEdit],

  mounted() {
    this.$validator.pause()
    this.$nextTick(() => {
      this.$validator.errors.clear()
      this.$validator.fields.items.forEach((field) => field.reset())
      this.$validator.fields.items.forEach((field) => this.errors.remove(field))
      this.$validator.resume()
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/TicketEdit.vue